import { auth0 } from '@/composables/useAuth0Client';

// Shared cache across the app for the Auth0 token response
let cachedTokenResponse = null;
let tokenExpiresAtMs = 0;
let inFlightPromise = null;

const EXPIRY_BUFFER_MS = 60 * 1000; // refresh 60s before expiry

async function fetchToken() {
  const { getAccessTokenSilently, loginWithRedirect } = auth0;

  try {
    const tokenResponse = await getAccessTokenSilently({
      prompt: 'none',
    });

    cachedTokenResponse = tokenResponse;
    const expiresInMs = (tokenResponse?.expires_in ?? 300) * 1000;
    tokenExpiresAtMs = Date.now() + expiresInMs - EXPIRY_BUFFER_MS;
    return cachedTokenResponse;
  } catch (error) {
    console.error('Error getting access token silently:', error);
    try {
      console.log('not authenticated - token');
      loginWithRedirect();
    } catch (e) {
      // ignore secondary redirect errors
    }
    return null;
  }
}

export default function useSilentAccessToken() {
  async function getAccessToken(forceRefresh = false) {
    const isCachedAndValid = !forceRefresh && cachedTokenResponse && Date.now() < tokenExpiresAtMs;

    if (isCachedAndValid) return cachedTokenResponse;

    if (inFlightPromise) return inFlightPromise;

    inFlightPromise = fetchToken().finally(() => {
      inFlightPromise = null;
    });

    return inFlightPromise;
  }

  function clearCachedAccessToken() {
    cachedTokenResponse = null;
    tokenExpiresAtMs = 0;
  }

  return { getAccessToken, clearCachedAccessToken };
}
